export const BLOK_YOUTUBE = "YoutubeVideo";
export const isYoutubeBlok = (props)=>Object.prototype.hasOwnProperty.call(props, "videoId") && Object.prototype.hasOwnProperty.call(props, "title") && Object.prototype.hasOwnProperty.call(props, "buttonLabel");
